export default {
    label: 'Contact form',
    phonePlaceholder: 'Telephone',
    description: 'Please leave your contact details and we will get in touch with you shortly.',
    submitButton: 'Submit',

    successMessageSent: 'The form was successfully submitted, we will contact you shortly.'
}
